var cache = {};
export {
  cache as __exports
};
//# sourceMappingURL=cache2.js.map
